export default __webpack_public_path__ + "static/media/marlene.e684af9a.png";